import Schools from '../../../interfaces/SchoolsInterface';

export interface SchoolSelectionOption {
  value: string;
  label: string;
  isExternal: boolean;
}

export const getSchoolSelectionOptions = (schools: Schools[]): SchoolSelectionOption[] =>
  schools.map((school) => ({
    value: school.id,
    label: school.name,
    isExternal: school.is_primary_on_eoa === false,
  }));

export const getSchoolIdsFromSelection = (selectedValues: string[], schools: Schools[]): string[] => {
  const schoolIds = new Set(schools.map((school) => school.id));
  return selectedValues.filter((value) => schoolIds.has(value));
};
